import * as Msal from 'msal'

export default class AuthService {
  constructor () {
    let PROD_REDIRECT_URI = ''
    let redirectUri = window.location.origin
    this.applicationConfig = {
      auth: {
      clientId: '',
      authority: '',
      redirectUri: redirectUri
      }
    }
    if (window.location.hostname !== '127.0.0.1') {
      redirectUri = PROD_REDIRECT_URI
    }
    if(process.env.NODE_ENV === 'development'){
      if(window.location.origin == 'https://localhost:44337'){
        PROD_REDIRECT_URI = 'https://localhost:44337/'
      }

      if(window.location.origin === 'https://onboardtemplates.exflowdev.cloud'){
        PROD_REDIRECT_URI = 'https://onboardtemplates.exflowdev.cloud'
      }
      if(window.location.origin === 'https://onboard.exflowdev.cloud'){
        PROD_REDIRECT_URI = 'https://onboard.exflowdev.cloud'
      }
      // PROD_REDIRECT_URI = 'https://onboardtemplates.exflowdev.cloud/'
      this.applicationConfig.auth.clientId = '4a751c6c-eb0b-49cf-8bdc-90b4274aeaa1'
      this.applicationConfig.auth.authority = 'https://login.microsoftonline.com/common'
    }

    if(process.env.NODE_ENV === 'production'){
      if(window.location.origin == 'https://localhost:44337'){
        PROD_REDIRECT_URI = 'https://localhost:44337/'
      }
      if(window.location.origin === 'https://onboardtemplates.exflow.cloud'){
        PROD_REDIRECT_URI = 'https://onboardtemplates.exflow.cloud'
      }
      if(window.location.origin === 'https://onboard.exflow.cloud'){
        PROD_REDIRECT_URI = 'https://onboard.exflow.cloud'
      }
      if(window.location.origin === 'https://onboardpre.exflow.cloud'){
        PROD_REDIRECT_URI = 'https://onboardpre.exflow.cloud'
      }
      //let PROD_REDIRECT_URI = 'https://onboard.exflow.cloud'
      this.applicationConfig.auth.clientId = '736cc031-68ce-4c8d-9d24-38a6ebb72ab9'
      this.applicationConfig.auth.authority = 'https://login.microsoftonline.com/common'
    }
    this.app = new Msal.UserAgentApplication(this.applicationConfig)
  }
  login () {
    let loginRequest = {
      scopes: ["user.read"],
      prompt: "select_account",
    }
    return this.app.loginPopup(loginRequest)
    .then(
      response => {
        let token = response.idToken.rawIdToken;
        const user = response.idToken.name;
        if (user) {             
          return {user, token}
        } else {
          console.log("no user found!", user);
          return null;
        }
      },
      e => {
        // console.log("caught error of idToken: ", e);
        return Promise.reject(e);
      }
    )
    // .catch(error => console.log("error is ", error))
  }
  logout () {
    this.app.logout()
  }
}
